import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "hidden not-prose mt-5 md:block",
  "aria-label": "Breadcrumb"
}
const _hoisted_2 = { class: "flex items-center space-x-4 my-3 pl-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  class: "flex-shrink-0 h-5 w-5",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Home", -1)
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  class: "flex-shrink-0 h-5 w-5 text-gray-300",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M5.555 17.776l8-16 .894.448-8 16-.894-.448z" })
], -1)
const _hoisted_7 = {
  key: 0,
  class: "ml-4 text-sm font-medium text-gray-500"
}

import { PropType } from 'vue';
import { Breadcrumb } from '@/model/Breadcrumb';


export default /*#__PURE__*/_defineComponent({
  __name: 'BreadcrumbsComponent',
  props: {
  routes: {
    type: Array as PropType<Array<Breadcrumb>>,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("ol", _hoisted_2, [
      _createElementVNode("li", null, [
        _createElementVNode("div", null, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "text-gray-400 hover:text-gray-500"
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              _hoisted_4
            ]),
            _: 1
          })
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.routes, (route, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: route.url
        }, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            (index === __props.routes.length - 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(route.title), 1))
              : (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  to: route.url,
                  class: "ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(route.title), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]))
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})